import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfigService } from 'src/app/shared/services/config.service';
import { DGPackage } from 'src/app/utils/constants/strings';

import {
  NOT_RESTRICTED_SPECIAL_PROVISION,
  configurationIdMapForShipmentDetailsUpdate,
  configurationIdMapForShipmentDetailsUpdateEvent,
} from 'src/app/utils/constants/constant';
import { createConfigArray } from 'src/app/utils/default-configs/configuration';
import { MawbService } from 'src/app/shared/services/mawb.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dg-content',
  templateUrl: './dg-content.component.html',
  styleUrls: ['./dg-content.component.css'],
})
export class DgContentComponent implements OnInit {
  dgContentForm: FormGroup;
  customDescriptions: any = [];
  showDGContentID: any;
  dgContentIdsList: any;
  showCustomDescHeader: boolean = false;
  hasHU5: boolean = false;
  dgContentIds = [];
  selectedPreDGContentIds: string[] = [];
  selectedDescription = [];
  DGContentFromConfig;
  DGContentIDValues;
  showDgCustomDescription = false;
  element: false;
  mawb: any;
  mawbDetails: any;
  selectedDGTabIndex: any = 0;
  enumDGPackage = DGPackage;
  selectedDGPackage: any = [];
  dgPackageDryIcelValue: any = [];
  dgPackageBiologicalValue: any = [];

  constructor(
    private configService: ConfigService,
    private MawbService: MawbService,
    private _fb: FormBuilder,
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    if (data.mawbId != null) {
      this.mawb = data.mawbId;
      this.mawbDetails = data;
    }
  }

  ngOnInit(): void {
    this.getAllDGContentIDs();
    this.intializeDgContentForm();
    this.initializeDGPackage();
  }

  initializeDGPackage() {
    this.dgPackageDryIcelValue =
      this.mawbDetails.DGPackageData.filter(
        d => d.contentId == this.enumDGPackage.DryIce.toString()
      ) || [];

    this.dgPackageBiologicalValue =
      this.mawbDetails.DGPackageData.filter(
        d => d.contentId == this.enumDGPackage.BiologicalSubstance.toString()
      ) || [];

    this.dgContentForm.patchValue({ DGPackageData: this.mawbDetails?.DGPackageData || [] });
  }

  intializeDgContentForm() {
    this.dgContentForm = this._fb.group({
      DGContentID: [this.mawbDetails?.dgContentId],
      DGCustomDescription: [this.mawbDetails?.customDescription?.[0]],
      DGPackageData: this.mawbDetails?.DGPackageData || [],
    });

    this.showDgCustomDescription = !!this.mawbDetails?.customDescription?.length;
  }

  selected(event) {
    this.selectedPreDGContentIds = event?.value;
  }

  get contentID() {
    return (
      this.dgContentForm.get('DGContentID').value?.includes('HU5') ||
      this.dgContentForm.get('DGContentID').value?.includes('E01')
    );
  }

  checkDgValidation(dgContentIdsList, customDescription) {
    if (
      dgContentIdsList &&
      dgContentIdsList.length > 0 &&
      (dgContentIdsList.includes('HU5') ||
        this.dgContentForm.get('DGContentID').value?.includes('E01'))
    ) {
      if (customDescription !== '') {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  getAllDGContentIDs() {
    this.configService
      .getConfigs(createConfigArray(configurationIdMapForShipmentDetailsUpdate))
      .then(response => {
        this.dgContentIds = response[0].data;
        this.getShowDGContentIDSetting();

        //initialize the tab selection for dryIce and Biological substance
        this.selectedDGPackage = this.getDGPackages(this.mawbDetails?.dgContentId);
      });
  }

  getShowDGContentIDSetting() {
    this.configService.getConfigs(['baby_default_options']).then(response => {
      if (response) {
        this.showDGContentID = response[0]?.data[0]?.showDGContentID;
        if (this.showDGContentID) {
          this.getDGContentData();
        } else {
          this.dgContentIdsList = [];
          this.customDescriptions = [];
        }
      }
    });
  }

  getDGContentData() {
    this.configService
      .getConfigs(createConfigArray(configurationIdMapForShipmentDetailsUpdateEvent))
      .then(response => {
        this.setDGContentId(response[0]?.data[0]);
        this.setDGContentCustomDescriptionValue(response[0]?.data[0]);
      });
  }

  setDGContentId(data: any) {
    this.DGContentFromConfig = data.DGContentID;
    this.dgContentIdsList = this.dgContentIds
      .map(e => {
        if (this.DGContentFromConfig?.includes(e.dg_content_id)) return e;
      })
      .filter(e => e?.code);
    if (this.DGContentFromConfig.includes('HU5') || this.DGContentFromConfig.includes('E01')) {
      this.showCustomDescHeader = true;
    } else {
      this.showCustomDescHeader = false;
    }
  }

  setDGContentCustomDescriptionValue(data: any) {
    if (data?.DGContentID.length > 0) {
      this.DGContentFromConfig = data.DGContentID;
      this.DGContentFromConfig?.includes('HU5') || this.DGContentFromConfig?.includes('E01')
        ? (this.customDescriptions = data?.customDescription)
        : (this.customDescriptions = []);
    }
  }

  changeDgContentID(e) {
    this.showDgCustomDescription =
      this.dgContentForm?.value?.DGContentID.includes(NOT_RESTRICTED_SPECIAL_PROVISION) ||
      this.dgContentForm?.value?.DGContentID.includes('E01');

    this.showDgCustomDescription
      ? this.dgContentForm.get('DGCustomDescription').setValidators([Validators.required])
      : this.dgContentForm.get('DGCustomDescription').clearValidators();
    if (!this.showDgCustomDescription) this.dgContentForm.patchValue({ DGCustomDescription: '' });

    //DG package un select reset value
    this.selectedDGPackage = this.getDGPackages(e?.value || []);

    if (
      !this.selectedDGPackage.filter(
        d => d.dg_content_id == this.enumDGPackage.BiologicalSubstance.toString()
      ).length
    )
      this.dgPackageBiologicalValue = [];

    if (
      !this.selectedDGPackage.filter(d => d.dg_content_id == this.enumDGPackage.DryIce.toString())
        .length
    )
      this.dgPackageDryIcelValue = [];

    //update DGPackage form data
    this.dgContentForm.patchValue({
      DGPackageData: [...this.dgPackageBiologicalValue, ...this.dgPackageDryIcelValue],
    });
  }

  checkCustomDescReq() {
    if (this.dgContentIdsList?.length > 0) {
      return this.dgContentIdsList?.includes('HU5') || this.dgContentIdsList?.includes('E01');
    }
  }

  addDgValues() {
    //check for DGPackage DryIce and Biological Substance

    const dgPackage = this.dgContentForm.get('DGPackageData').value;
    const DGContentID = this.dgContentForm.value.DGContentID;
    let hasDGPackage = DGContentID.filter(
      d =>
        d == this.enumDGPackage.DryIce.toString() ||
        d == this.enumDGPackage.BiologicalSubstance.toString()
    );

    if (hasDGPackage) {
      const noDryIce =
        dgPackage.filter(d => d.contentId == this.enumDGPackage.DryIce.toString()).length == 0;
      const noBiological =
        dgPackage.filter(d => d.contentId == this.enumDGPackage.BiologicalSubstance.toString())
          .length == 0;

      if (noDryIce) {
        const idx = DGContentID.indexOf(this.enumDGPackage.DryIce.toString());
        if (idx > -1) DGContentID.splice(idx, 1);
      }

      if (noBiological) {
        const idx = DGContentID.indexOf(this.enumDGPackage.BiologicalSubstance.toString());
        if (idx > -1) DGContentID.splice(idx, 1);
      }

      this.dgContentForm.patchValue({
        DGContentID: DGContentID,
      });
    }

    const request = {
      DGCustomDescription: [this.dgContentForm.value.DGCustomDescription],
      DGContentID: this.dgContentForm.value.DGContentID,
      mawb: this.mawb,
      DGPackageData: this.dgContentForm.get('DGPackageData').value,
    };
    this.MawbService.dgContentValues(request).subscribe(() => {
      this.dialogRef.close(true);
    });
  }
  disableSave() {
    return (
      this.dgContentForm.valid &&
      this.dgContentForm.dirty &&
      this.dgContentForm.value.DGContentID.length > 0
    );
  }

  getDGPackages(e: any) {
    let ff = e.filter(
      f =>
        f == this.enumDGPackage.BiologicalSubstance.toString() ||
        f == this.enumDGPackage.DryIce.toString()
    );

    let dd = ff.map(f => {
      return this.dgContentIds.filter(d => d.dg_content_id == f.toString())[0];
    });

    return dd;
  }

  dgSelected(v) {
    return this.dgContentForm.get('DGContentID').value?.includes(v.toString());
  }

  dgPackageDryIcelValueChange(e) {
    let dgCleanData = e?.filter(dg => dg.packageNo > 0 && dg.packageWeight > 0);
    let dgValue =
      this.dgContentForm
        .get('DGPackageData')
        .value?.filter(d => d.contentId != this.enumDGPackage.DryIce.toString()) || [];

    const mapData = [...dgValue, ...dgCleanData].map(d => {
      return {
        contentId: d.contentId,
        packageNo: d.packageNo,
        packageWeight: d.packageWeight,
      };
    });

    this.dgContentForm.markAsDirty();
    this.dgContentForm.patchValue({ DGPackageData: mapData });
  }

  dgPackageBiologicalValueChange(e) {
    let dgCleanData = e?.filter(dg => dg.packageNo > 0);
    let dgValue =
      this.dgContentForm
        .get('DGPackageData')
        .value?.filter(d => d.contentId != this.enumDGPackage.BiologicalSubstance.toString()) || [];

    const mapData = [...dgValue, ...dgCleanData].map(d => {
      return {
        contentId: d.contentId,
        packageNo: d.packageNo,
        packageWeight: d.packageWeight,
      };
    });

    this.dgContentForm.markAsDirty();
    this.dgContentForm.patchValue({ DGPackageData: mapData });
  }
}
